import { render, staticRenderFns } from "./consent-account-transaction-days-tab.vue?vue&type=template&id=37f87e9b&scoped=true"
import script from "./consent-account-transaction-days-tab.vue?vue&type=script&lang=js"
export * from "./consent-account-transaction-days-tab.vue?vue&type=script&lang=js"
import style0 from "./consent-account-transaction-days-tab.vue?vue&type=style&index=0&id=37f87e9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f87e9b",
  null
  
)

export default component.exports